export const path = "integracao/csv-cursos";
